module.exports = __webpack_public_path__ + "Yfz3EKkuEAXohMTFW/illo-couple-phone.svg";